import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import type { ThemeType } from 'primeng/config';

// Primary = the Everplan brand accent (#6161FF at 500), aligned with the logo
// mark. A tint/shade ramp kept in the indigo/periwinkle family so darks read as
// indigo, not pure blue. Brand color is the single source — see the design
// system's branding + color foundations.
const EverplanPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f2f2ff',
      100: '#e6e6ff',
      200: '#ccccff',
      300: '#aaaaff',
      400: '#8484ff',
      500: '#6161ff',
      600: '#5554e0',
      700: '#4a49c5',
      800: '#3f3ea9',
      900: '#363592',
      950: '#2a2873',
    },
  },
});

export const theme: ThemeType = {
  preset: EverplanPreset,
  options: {
    // No dark mode toggle — light only for now
    darkModeSelector: false,
    cssLayer: {
      name: 'primeng',
      order: 'theme, base, primeng',
    },
  },
};
